import React, { useRef } from 'react'
import './index.css'

const ArrowTooltip = ({ children, toolTipContent, position = 'top', left, ...rest }) => {
  const toolTipRef = useRef(null)

  return (
    <div ref={toolTipRef} className={'con-tooltip ' + position}>
      {children}
      <div className="tooltip ">
        <div className="tooltip-container">
          <div className="tooltip-content">
            <div className="toolContent my-auto">{toolTipContent()}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArrowTooltip
